import { useAsPath } from 'src/hooks/useAsPath';

import { Calculator, CalculatorProps } from '../Calculator';

// const CalculatorAndTariffPlans = ({ ...rest }: CalculatorProps) => {
//   return <TariffPlans initialActiveProduct={rest.initialActiveProduct} />;
// };

export function CalculatorSite({ ...rest }: CalculatorProps) {
  const asPath = useAsPath();

  // key={router.asPath} сделано для https://jira.sbercloud.tech/browse/ONB-977
  // https://nextjs.org/docs/pages/api-reference/functions/use-router#resetting-state-after-navigation
  return <Calculator key={asPath} {...rest} />;
}
